export default ({ app, $config }, inject) => {
    if (process.client) {
        const store = app.store
        // 🔹 Using store state directly instead of fetching API
        const pwa = store.state['banner-pwa']?.pwa
        // Only run on store/banner pages where pwa data exists
        if (!pwa?.pwa_app_settings) return

        // 🔹 Construct app icon URL from config + store
        const appIcon = `${$config.BUCKET_ROOT}/assets/banners/app_icons/${pwa?.pwa_app_settings?.app_icon}`

        // Inject dynamic redirect for iOS standalone
        window.addEventListener('load', () => {
            const isIos = /iPhone|iPad|iPod/i.test(navigator.userAgent)
            const isStandalone = window.navigator.standalone === true

            if (isIos && isStandalone) {
                const urlParams = new URLSearchParams(window.location.search)
                // 🔹 Use store state px_id for pixel param
                if (!urlParams.has('pixel')) {
                    window.location.replace(`/?pixel=${pwa?.px_id || ''}`)
                }
            }
        })

        // Inject meta dynamically
        const head = document.getElementsByTagName('head')[0]

        const metaTags = [
            { name: 'apple-mobile-web-app-capable', content: 'yes' },
            { name: 'mobile-web-app-capable', content: 'yes' },
            {
                name: 'apple-mobile-web-app-status-bar-style',
                content: 'black-translucent',
            },
            {
                name: 'apple-mobile-web-app-title',
                // 🔹 Use store state app_name, fallback to 'App name'
                content: pwa?.pwa_app_settings?.app_name || '',
            },
        ]

        metaTags.forEach((meta) => {
            const el = document.createElement('meta')
            Object.keys(meta).forEach((k) => el.setAttribute(k, meta[k]))
            head.appendChild(el)
        })

        // Apple icon
        const link = document.createElement('link')
        link.setAttribute('rel', 'apple-touch-icon')
        link.setAttribute('sizes', '180x180')
        // 🔹 Use store appIcon URL
        link.setAttribute('href', appIcon || '/apple-touch-icon.png')
        head.appendChild(link)
    }
}
